import React, { CSSProperties, PropsWithChildren } from 'react';

type FlexProps = PropsWithChildren<{
    gap?: number | string;
    align?: CSSProperties['alignItems'];
    justify?: CSSProperties['justifyContent'];
    direction?: CSSProperties['flexDirection'];
    style?: CSSProperties;
    className?: string;
}>;

const Flex = ({
    children,
    gap = 8,
    align = 'center',
    justify = 'flex-start',
    direction = 'row',
    style = {},
    className,
}: FlexProps) => {
    return (
        <div
            className={className}
            style={{
                display: 'flex',
                gap,
                alignItems: align,
                justifyContent: justify,
                flexDirection: direction,
                ...style,
            }}
        >
            {children}
        </div>
    );
};

export default Flex;
